import moment from 'moment';

// Filtros do Calendário (/calendario/:id/:department), guardados com
// usePersistedFilters. Mês como 'YYYY-MM' (nunca moment), status como lista
// ordenada de 0 (Atrasadas), 1 (Pendentes), 2 (Concluídas).

export var ALL_STATUSES = [0, 1, 2];

// Cada calendário (departamento) tem os seus filtros.
export var getCalendarFiltersKey = function(id, departmentParam) {
  return 'calendario:' + id + ':' + departmentParam;
};

export var getDefaultCalendarFilters = function() {
  return {
    month: moment().format('YYYY-MM'),
    actived: ALL_STATUSES.slice(),
    search: '',
  };
};

// Mês salvo inválido (ou ausente) volta para o padrão.
export var normalizeMonth = function(month, fallback) {
  var parsed = month ? moment(month, 'YYYY-MM', true) : null;
  if (parsed && parsed.isValid()) return parsed.format('YYYY-MM');
  return fallback;
};

// Liga/desliga um status mantendo a lista ordenada, para que "todos marcados"
// seja sempre igual ao padrão [0, 1, 2].
export var toggleStatus = function(actived, value) {
  var current = Array.isArray(actived) ? actived : [];
  var next = current.indexOf(value) !== -1
    ? current.filter(function(n) { return n !== value; })
    : current.concat([value]);
  return next.slice().sort();
};

export var isDefaultStatuses = function(actived) {
  return Array.isArray(actived) &&
    actived.length === ALL_STATUSES.length &&
    ALL_STATUSES.every(function(v) { return actived.indexOf(v) !== -1; });
};

// Badge: conta só o que difere do padrão e está de fato aplicado. O status só
// filtra no modo lista, então no modo caixa ele não conta.
export var getCalendarFilterCount = function(filters, defaults, visualizationMode) {
  var count = 0;
  if (filters.month !== defaults.month) count += 1;
  if (visualizationMode === 'list' && !isDefaultStatuses(filters.actived)) count += 1;
  if (filters.search) count += 1;
  return count;
};

// Loading do mês selecionado (não do mês atual).
export var isMonthLoading = function(calendarTasks, departmentId, month) {
  var key = moment(month, 'YYYY-MM').format('YYYY/MM');
  var departmentData = calendarTasks && calendarTasks[departmentId];
  var dateData = departmentData && departmentData[key];
  return !!(dateData && dateData.loading);
};
